module.exports = __webpack_public_path__ + "img/vps_icon_pic.514eae0.png";